<template>

<v-card class="app-center">
  <v-toolbar
    color="light-blue lighten-1"
    cards
    dark
    flat
    height="70px">
    <v-card-title class="title font-weight-regular">{{ user.name }}</v-card-title>
  </v-toolbar>

  <v-form
      ref="form"
      class="pa-3 pt-4"
    >

      <v-text-field
        name="name"
        v-model="name"
        color="deep-purple"
        label="Full name"
        hide-details
        ref="name"
        v-validate="'required'"
        :class="{'mb-3': !errors.has('name')}"
      ></v-text-field>
      <div class="red--text mb-3">{{ errors.first('name') }}</div>

      <v-text-field
        v-model="password"
        name="password"
        ref="password"
        color="deep-purple"
        counter="6"
        label="Password"
        v-validate="'min:6'"
        type="password"
        hide-details
        :class="{'mb-3': !errors.has('password')}"
      ></v-text-field>
      <div class="red--text mb-4">{{ errors.first('password') }}</div>

    </v-form>

    <v-card-actions>

      <v-btn small flat router-link to="/address-book">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="white--text"
        color="blue darken-2"
        @click="updateProfile"
      >Update</v-btn>
    </v-card-actions>

</v-card>

</template>

<script>

export default {
  data () {
    return {
      name: null,
      password: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    updateProfile () {
      this.$validator.validate().then(result => {
        if (!result) {
          console.log('still errors there')
        } else {
          let userData = { name: this.name }

          if (this.password) {
            userData.password = this.password
          }
          this.$store.dispatch('updateUser', userData)
        }
      }
    )}
  },
  mounted () {
    this.name = this.user.name
    this.$refs.password.focus()
  }
}

</script>

<style>

</style>
